'use strict';
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dStatus from "./app.data.-General-Practice-Status.js";
import * as $j_app$002edata$002e$002dNot$002dAn$002dE$002dP$002dS$002dCode$002dError$0024 from "./app.data.-Not-An-E-P-S-Code-Error$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_types\uff3fdrug$package$EPSCode$() {
  this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_defaultMake$lzy25 = null;
  this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_defaultMakebitmap$25 = false;
  this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_make$lzy25 = null;
  this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_makebitmap$25 = false;
  this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_given_Show_Type$lzy22 = null;
  this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_given_Show_Typebitmap$22 = false;
  this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_tapirCodec$lzy11 = null;
  this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_tapirCodecbitmap$11 = false;
  this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_urlConvertible$lzy11 = null;
  this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_urlConvertiblebitmap$11 = false;
  this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_validator = null;
  this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_given_LocalizedTextOf_Type$lzy19 = null;
  this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_given_LocalizedTextOf_Typebitmap$19 = false;
  this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_Aborted$lzy1 = null;
  this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_Abortedbitmap$1 = false;
  $n_Lapp_data_types\uff3fdrug$package$EPSCode$ = this;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validator$();
  var x = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lyantl_ValidatorRule.getArrayOf().constr)([$j_app$002edata$002e$002dNot$002dAn$002dE$002dP$002dS$002dCode$002dError$0024.$m_Lapp_data_NotAnEPSCodeError$().Lapp_data_NotAnEPSCodeError$__f_validatorRule, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lyantl_ValidatorRule$$anon$13()]);
  this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validator$().fromRules__ALyantl_ValidatorRule__Lyantl_Validator(x);
}
export { $c_Lapp_data_types\uff3fdrug$package$EPSCode$ as $c_Lapp_data_types\uff3fdrug$package$EPSCode$ };
$c_Lapp_data_types\uff3fdrug$package$EPSCode$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_types\uff3fdrug$package$EPSCode$.prototype.constructor = $c_Lapp_data_types\uff3fdrug$package$EPSCode$;
/** @constructor */
function $h_Lapp_data_types\uff3fdrug$package$EPSCode$() {
}
export { $h_Lapp_data_types\uff3fdrug$package$EPSCode$ as $h_Lapp_data_types\uff3fdrug$package$EPSCode$ };
$h_Lapp_data_types\uff3fdrug$package$EPSCode$.prototype = $c_Lapp_data_types\uff3fdrug$package$EPSCode$.prototype;
$c_Lapp_data_types\uff3fdrug$package$EPSCode$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_defaultMakebitmap$25)) {
    this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_defaultMake$lzy25 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_defaultMakebitmap$25 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_defaultMake$lzy25;
});
$c_Lapp_data_types\uff3fdrug$package$EPSCode$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_makebitmap$25)) {
    this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_make$lzy25 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_makebitmap$25 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_make$lzy25;
});
$c_Lapp_data_types\uff3fdrug$package$EPSCode$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lapp_data_types\uff3fdrug$package$EPSCode$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lapp_data_types\uff3fdrug$package$EPSCode$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lapp_data_types\uff3fdrug$package$EPSCode$.prototype.given_Show_Type__Lcats_Show = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_given_Show_Typebitmap$22)) {
    this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_given_Show_Type$lzy22 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_given_Show_Typebitmap$22 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_given_Show_Type$lzy22;
});
$c_Lapp_data_types\uff3fdrug$package$EPSCode$.prototype.tapirCodec__Lsttp_tapir_Codec = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_tapirCodecbitmap$11)) {
    this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_tapirCodec$lzy11 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeString__tapirCodec__Lsttp_tapir_Codec(this);
    this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_tapirCodecbitmap$11 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_tapirCodec$lzy11;
});
$c_Lapp_data_types\uff3fdrug$package$EPSCode$.prototype.urlConvertible__Lframework_utils_UrlConvertible = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_urlConvertiblebitmap$11)) {
    var codec = this.tapirCodec__Lsttp_tapir_Codec();
    var errorFromThrowable = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lurldsl_errors_DummyError$().dummyErrorIsFromThrowable__Lurldsl_errors_ErrorFromThrowable();
    this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_urlConvertible$lzy11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_utils_UrlConvertible$fromCodec(codec, errorFromThrowable);
    this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_urlConvertiblebitmap$11 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_urlConvertible$lzy11;
});
$c_Lapp_data_types\uff3fdrug$package$EPSCode$.prototype.validate__Lyantl_Validate = (function() {
  return this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_validator;
});
$c_Lapp_data_types\uff3fdrug$package$EPSCode$.prototype.given_LocalizedTextOf_Type__Lframework_localization_LocalizationSupport$LocalizedTextOf = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_given_LocalizedTextOf_Typebitmap$19)) {
    var this$1 = $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().LocalizedTextOf__Lframework_localization_LocalizationSupport$LocalizedTextOf$();
    var this$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_localization_LocalizationSupport$$anon$7(this$1);
    var x = $j_app$002edata$002e$002dGeneral$002dPractice$002dStatus.$m_Lapp_localization_L18n$().Lapp_localization_L18n$__f_EPS$u0020Code;
    this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_given_LocalizedTextOf_Type$lzy19 = this$2.apply__Lframework_localization_LocalizationSupport$LocalizedText__Lframework_localization_LocalizationSupport$LocalizedTextOf(x);
    this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_given_LocalizedTextOf_Typebitmap$19 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_given_LocalizedTextOf_Type$lzy19;
});
$c_Lapp_data_types\uff3fdrug$package$EPSCode$.prototype.Aborted__T = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_Abortedbitmap$1)) {
    var this$1 = this.make__Lyantl_INewtype$make$();
    var x$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype$package$().given_AsString_Any__Lyantl_AsString();
    this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_Aborted$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lyantl_Make__orThrow__O__Lyantl_AsString__O(this$1, "0rapix-aborte-d00000", x$2);
    this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_Abortedbitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$EPSCode$__f_Aborted$lzy1;
});
var $d_Lapp_data_types\uff3fdrug$package$EPSCode$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_types\uff3fdrug$package$EPSCode$, "app.data.types_drug$package$EPSCode$", ({
  Lapp_data_types\uff3fdrug$package$EPSCode$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lframework_utils_NewtypeString: 1,
  Lyantl_Newtype$ValidatedOf: 1
}));
export { $d_Lapp_data_types\uff3fdrug$package$EPSCode$ as $d_Lapp_data_types\uff3fdrug$package$EPSCode$ };
var $n_Lapp_data_types\uff3fdrug$package$EPSCode$;
function $m_Lapp_data_types\uff3fdrug$package$EPSCode$() {
  if ((!$n_Lapp_data_types\uff3fdrug$package$EPSCode$)) {
    $n_Lapp_data_types\uff3fdrug$package$EPSCode$ = new $c_Lapp_data_types\uff3fdrug$package$EPSCode$();
  }
  return $n_Lapp_data_types\uff3fdrug$package$EPSCode$;
}
export { $m_Lapp_data_types\uff3fdrug$package$EPSCode$ as $m_Lapp_data_types\uff3fdrug$package$EPSCode$ };
//# sourceMappingURL=app.data.types_drug$package$-E-P-S-Code$.js.map
